import styled from 'styled-components';

const StyledExternal = styled.a`
  color: #379683;
  font-family: inherit;
  font-weight: bold;
  text-decoration: none;
  cursor: pointer;
`;

export default StyledExternal;
